
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/usr/src/app/ui/shared/avatar/jst/-avatar';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.anonymous), {hash:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n<a class=\"avatar\" style=\"background-image: url(/images/messages/avatar-50.png)\">\n  <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("avatar")
  },data:data},helper ? helper.call(depth0, "student_5da6bfd1", "Student", options) : helperMissing.call(depth0, "t", "student_5da6bfd1", "Student", options)))
    + "</span>\n</a>\n";
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n";
  stack1 = (helper = helpers.ifAny || (depth0 && depth0.ifAny),options={hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.avatar_url), (depth0 && depth0.avatar_image_url), options) : helperMissing.call(depth0, "ifAny", (depth0 && depth0.avatar_url), (depth0 && depth0.avatar_image_url), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  }
function program5(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.alreadyEscaped), {hash:{},inverse:self.program(9, program9, data),fn:self.program(6, program6, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  }
function program6(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n<a ";
  stack1 = (helper = helpers.ifAny || (depth0 && depth0.ifAny),options={hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.url), (depth0 && depth0.html_url), options) : helperMissing.call(depth0, "ifAny", (depth0 && depth0.url), (depth0 && depth0.html_url), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " class=\"fs-exclude avatar\"\n  style=\"background-image: url(";
  stack1 = (helper = helpers.or || (depth0 && depth0.or),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.avatar_url), (depth0 && depth0.avatar_image_url), options) : helperMissing.call(depth0, "or", (depth0 && depth0.avatar_url), (depth0 && depth0.avatar_image_url), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ")\">\n  <span class=\"screenreader-only\">";
  stack1 = (helper = helpers.or || (depth0 && depth0.or),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.display_name), (depth0 && depth0.short_name), options) : helperMissing.call(depth0, "or", (depth0 && depth0.display_name), (depth0 && depth0.short_name), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</span></a>\n";
  return buffer;
  }
function program7(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "href=\"";
  stack1 = (helper = helpers.or || (depth0 && depth0.or),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.url), (depth0 && depth0.html_url), options) : helperMissing.call(depth0, "or", (depth0 && depth0.url), (depth0 && depth0.html_url), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\" ";
  return buffer;
  }

function program9(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n<a ";
  stack1 = (helper = helpers.ifAny || (depth0 && depth0.ifAny),options={hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.url), (depth0 && depth0.html_url), options) : helperMissing.call(depth0, "ifAny", (depth0 && depth0.url), (depth0 && depth0.html_url), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " class=\"fs-exclude avatar\"\n  style=\"background-image: url("
    + escapeExpression((helper = helpers.or || (depth0 && depth0.or),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.avatar_url), (depth0 && depth0.avatar_image_url), options) : helperMissing.call(depth0, "or", (depth0 && depth0.avatar_url), (depth0 && depth0.avatar_image_url), options)))
    + ")\"><span\n    class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.or || (depth0 && depth0.or),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.display_name), (depth0 && depth0.short_name), options) : helperMissing.call(depth0, "or", (depth0 && depth0.display_name), (depth0 && depth0.short_name), options)))
    + "</span></a>\n";
  return buffer;
  }
function program10(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "href=\""
    + escapeExpression((helper = helpers.or || (depth0 && depth0.or),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.url), (depth0 && depth0.html_url), options) : helperMissing.call(depth0, "or", (depth0 && depth0.url), (depth0 && depth0.html_url), options)))
    + "\" ";
  return buffer;
  }

  buffer += "\n";
  stack1 = helpers['if'].call(depth0, depth0, {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  return buffer;
  });
    
      Handlebars.registerPartial('ui/shared/avatar/jst/_avatar.handlebars', templates['/usr/src/app/ui/shared/avatar/jst/-avatar']);
    ;
    ;
    export default templates[name];
  